<template>
  <div id="app">
    <head-Back title="加载中"></head-Back>
    <div class="loading-div">
      <img class="loading" src="../../assets/img/timg.gif" />
      <p>页面加载中…</p>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back-app";
import { mapGetters } from "vuex";
//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";

export default {
  name: "app",
  data() {
    return {
      msg: "正在加载",
      flag: true,
      url: "",
      mjb: ""
    };
  },
  mounted() {
    console.log("加载完成");
    this.getSecond();
  },
  methods: {
    //发送验证码
    getSecond() {
      var url = util.getParams("path");
      var cid = util.getParams("cid");
      

       if (cid != null && cid != undefined && cid != "") {
        store.commit(types.SET_CHANNEL, cid);
      }

      if (url != null && url != undefined && url != "") {
        this.$router.push("/" + decodeURIComponent(url));
      } else {
        this.$router.push("/login")
      }
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
.loading-div {
  width: 750px;
  height: auto;
  margin: 220px auto 20px;
}
.loading {
  width: 112px;
  height: 112px;
}
.loading-div p {
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/indexLoad.vue